export const ROW_HIGHLIGHT_HOVER_CLASSES = "hover:bg-surface-1-hover"

export const KEYBOARD_ACTIVE_ROW_CLASSES = "!bg-surface-1 hover:!bg-surface-1"

export const KEYBOARD_ACTIVE_ROW_STYLE = {
  backgroundColor: "var(--surface-1)",
} as const
